// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".profile_icon[data-v-7090cb84]{border-radius:50px;display:flex;justify-content:center;align-items:center;gap:2px;color:var(--foreground-rgb);text-align:center;font-family:Proxima Nova,sans-serif;font-style:normal;font-weight:500}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
